<template>
  <div class="app-wrapper">
    <div class="map-container">
    <!-- ページタイトル（左上固定位置） -->
    <div class="page-title">
      <span class="title-text">バイク駐輪可能性判定 宿マップ</span>
      <div class="menu-container">
        <button class="hamburger-menu" @click="toggleMenu" :class="{ active: isMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <!-- ドロップダウンメニュー -->
        <div class="dropdown-menu" :class="{ show: isMenuOpen }">
          <button class="menu-item" @click="clearAllSelections">
            全ての選択クリア
          </button>
          <!-- <button class="menu-item" @click="openPrivacyPolicy">
            当サイトについて
          </button> -->
          <router-link to="/about-site" class="menu-item" @click="closeMenu">
            当サイトについて
          </router-link>
          <router-link to="/privacy-policy" class="menu-item" @click="closeMenu">
            プライバシーポリシー
          </router-link>
          <router-link to="/contact" class="menu-item" @click="closeMenu">
            お問い合わせ
          </router-link>
        </div>
      </div>
    </div>
    <!-- サイドバー（都道府県選択またはプライバシーポリシーまたはお問い合わせ） -->
    <aside class="sidebar" :class="{ expanded: isExpanded }">
      <!-- 都道府県選択画面 -->
      <div v-if="!showAboutSite && !showPrivacyPolicyOnly && !showContactForm" class="sidebar-content">
        <!-- ドラッグハンドル（小さい画面のみ表示） -->
        <div class="drag-handle" @click="toggleExpand">
          <span class="drag-bar"></span>
        </div>

        <!-- ピンの色フィルター -->
        <div class="sidebar-header">
          <h2 class="sidebar-title">駐輪可能性</h2>
        </div>
        <div class="filter-option">
          <label class="filter-checkbox-label">
            <input type="checkbox" v-model="visibleJudgments" value="1" />
            <svg width="14" height="18" viewBox="0 0 32 42" class="filter-pin-icon">
              <path d="M16 0C7.163 0 0 7.163 0 16c0 8.837 16 26 16 26s16-17.163 16-26C32 7.163 24.837 0 16 0z"
                    fill="#4CAF50" stroke="white" stroke-width="2"/>
              <circle cx="16" cy="16" r="6" fill="white"/>
            </svg>
            <span>可能性:大</span>
          </label>
          <label class="filter-checkbox-label">
            <input type="checkbox" v-model="visibleJudgments" value="2" />
            <svg width="14" height="18" viewBox="0 0 32 42" class="filter-pin-icon">
              <path d="M16 0C7.163 0 0 7.163 0 16c0 8.837 16 26 16 26s16-17.163 16-26C32 7.163 24.837 0 16 0z"
                    fill="#FFC107" stroke="white" stroke-width="2"/>
              <circle cx="16" cy="16" r="6" fill="white"/>
            </svg>
            <span>可能性:中</span>
          </label>
          <label class="filter-checkbox-label">
            <input type="checkbox" v-model="visibleJudgments" value="3" />
            <svg width="14" height="18" viewBox="0 0 32 42" class="filter-pin-icon">
              <path d="M16 0C7.163 0 0 7.163 0 16c0 8.837 16 26 16 26s16-17.163 16-26C32 7.163 24.837 0 16 0z"
                    fill="#F44336" stroke="white" stroke-width="2"/>
              <circle cx="16" cy="16" r="6" fill="white"/>
            </svg>
            <span>可能性:低</span>
          </label>
        </div>
        <!-- 展開可能セクション -->
        <div class="expandable-section">
          <div class="sidebar-header">
            <h2 class="sidebar-title">都道府県選択</h2>
          </div>
        <div class="pref-checkbox-box">
        <fieldset v-for="(prefs, region) in prefectureGroups" :key="region" class="pref-fieldset">
          <legend>
            <label class="region-checkbox-label">
              <input type="checkbox"
                :checked="isRegionSelected(region)"
                @change="toggleRegion(region)"
              />
              {{ region }}
            </label>
          </legend>
          <div class="pref-checkbox-list">
            <label v-for="pref in prefs" :key="pref" class="pref-checkbox-label" :class="{ selected: selectedPrefs.includes(pref) }"
              @click.prevent="handlePrefClick(pref)"
            >
              <input type="checkbox" :value="pref" v-model="selectedPrefs" />
              {{ pref }}
            </label>
          </div>
        </fieldset>
      </div>
        </div>
      </div>
      <!-- 当サイトについて画面 -->
      <div v-else-if="showAboutSite" class="sidebar-content">
        <!-- ドラッグハンドル（小さい画面のみ表示） -->
        <div class="drag-handle" @click="toggleExpand">
          <span class="drag-bar"></span>
        </div>
        <div class="about-site-header">
          <h2 class="sidebar-title">当サイトについて</h2>
          <button class="close-button" @click="closeAboutSite">
            <span>&times;</span>
          </button>
        </div>
        <div class="about-site-body">
          <AboutSite />
        </div>
      </div>
      <!-- プライバシーポリシー画面 -->
      <div v-else-if="showPrivacyPolicyOnly" class="sidebar-content">
        <!-- ドラッグハンドル（小さい画面のみ表示） -->
        <div class="drag-handle" @click="toggleExpand">
          <span class="drag-bar"></span>
        </div>
        <div class="privacy-policy-only-header">
          <h2 class="sidebar-title">プライバシーポリシー</h2>
          <button class="close-button" @click="closePrivacyPolicyOnly">
            <span>&times;</span>
          </button>
        </div>
        <div class="privacy-policy-only-body">
          <PrivacyPolicyOnly />
        </div>
      </div>
      <!-- お問い合わせ画面 -->
      <div v-else-if="showContactForm" class="sidebar-content">
        <!-- ドラッグハンドル（小さい画面のみ表示） -->
        <div class="drag-handle" @click="toggleExpand">
          <span class="drag-bar"></span>
        </div>
        <ContactForm @close="closeContactForm" />
      </div>
    </aside>
    <!-- マップ -->
    <div class="map-main">
      <l-map ref="mapRef" :zoom="zoom" :center="center" :zoom-control="false" style="height: 100vh; width: 100%;" :options="{zoomControl: false, doubleClickZoom: false}" @ready="onMapReady">
        <l-control-zoom position="bottomright"></l-control-zoom>
        <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" layer-type="base" name="OpenStreetMap" attribution='&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors'></l-tile-layer>
      </l-map>
    </div>
  </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed, watch } from 'vue';
import { LMap, LTileLayer, LControlZoom } from '@vue-leaflet/vue-leaflet';
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster";
import ContactForm from './ContactForm.vue';
import PrivacyPolicyOnly from './PrivacyPolicyOnly.vue';
import AboutSite from './AboutSite.vue';
import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3';
import { useRoute, useRouter } from 'vue-router';

export default defineComponent({
  name: 'HotelMap',
  components: {
    LMap,
    LTileLayer,
    LControlZoom,
    ContactForm,
    PrivacyPolicyOnly,
    AboutSite
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    
    const center = ref([35.6762, 139.6503]); // 東京の座標
    const zoom = ref(8);
    const hotels = ref([]);
    const mapRef = ref(null);
    const mapObject = ref(null);
    let clusterGroups = { green: null, yellow: null, red: null };

    // ルートに基づいてサイドバーの表示状態を計算
    const showAboutSite = computed(() => route.path === '/about-site');
    const showPrivacyPolicyOnly = computed(() => route.path === '/privacy-policy');
    const showContactForm = computed(() => route.path === '/contact');
    // 当サイトについてを閉じる関数
    const closeAboutSite = () => {
      router.push('/');
    };

    // judgmentの値に応じてマーカーのアイコンを返す関数
    const getMarkerIcon = (judgment) => {
      let color;
      switch(judgment) {
        case 1:
          color = '#4CAF50'; // 緑
          break;
        case 2:
          color = '#FFC107'; // 黄色
          break;
        case 3:
          color = '#F44336'; // 赤
          break;
        default:
          color = '#2196F3'; // デフォルト青
      }

      return L.divIcon({
        className: 'custom-marker-icon',
        html: `
          <svg width="24" height="32" viewBox="0 0 32 42" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 0C7.163 0 0 7.163 0 16c0 8.837 16 26 16 26s16-17.163 16-26C32 7.163 24.837 0 16 0z"
                  fill="${color}" stroke="white" stroke-width="2"/>
            <circle cx="16" cy="16" r="6" fill="white"/>
          </svg>
        `,
        iconSize: [24, 32],
        iconAnchor: [12, 32],
        popupAnchor: [0, -32]
      });
    };

    // judgmentの値に応じてz-indexを返す関数（駐輪可を最前面に）
    const getZIndexOffset = (judgment) => {
      switch(judgment) {
        case 1:
          return 1000; // 駐輪可（緑）を最前面
        case 2:
          return 500; // 条件付き（黄色）を中間
        case 3:
          return 0; // 駐輪不可（赤）を背面
        default:
          return 0;
      }
    };

    const selectedPrefs = ref([]);
    const isMenuOpen = ref(false);
    const visibleJudgments = ref([1, 2]); // デフォルトで駐輪可と条件付きのみ表示
    const isExpanded = ref(false); // サイドバーの展開状態
    
    // middleClassCodeと都道府県の対応マップ（地域コード一覧.jsonより）
    const middleClassCodeMap = {
      'hokkaido': '北海道',
      'aomori': '青森県',
      'iwate': '岩手県',
      'miyagi': '宮城県',
      'akita': '秋田県',
      'yamagata': '山形県',
      'hukushima': '福島県',
      'ibaragi': '茨城県',
      'tochigi': '栃木県',
      'gunma': '群馬県',
      'saitama': '埼玉県',
      'tiba': '千葉県',
      'tokyo': '東京都',
      'kanagawa': '神奈川県',
      'niigata': '新潟県',
      'toyama': '富山県',
      'ishikawa': '石川県',
      'hukui': '福井県',
      'yamanasi': '山梨県',
      'nagano': '長野県',
      'gihu': '岐阜県',
      'shizuoka': '静岡県',
      'aichi': '愛知県',
      'mie': '三重県',
      'shiga': '滋賀県',
      'kyoto': '京都府',
      'osaka': '大阪府',
      'hyogo': '兵庫県',
      'nara': '奈良県',
      'wakayama': '和歌山県',
      'tottori': '鳥取県',
      'simane': '島根県',
      'okayama': '岡山県',
      'hiroshima': '広島県',
      'yamaguchi': '山口県',
      'tokushima': '徳島県',
      'kagawa': '香川県',
      'ehime': '愛媛県',
      'kouchi': '高知県',
      'hukuoka': '福岡県',
      'saga': '佐賀県',
      'nagasaki': '長崎県',
      'kumamoto': '熊本県',
      'ooita': '大分県',
      'miyazaki': '宮崎県',
      'kagoshima': '鹿児島県',
      'okinawa': '沖縄県'
    };
    
    // フィルタリングされたホテルのcomputed property
    const filteredHotels = computed(() => {
      let filtered = hotels.value;
      
      // judgmentのフィルタリング（選択されたjudgmentのみ表示）
      const visibleJudgmentNumbers = visibleJudgments.value.map(v => parseInt(v));
      filtered = filtered.filter(hotel => visibleJudgmentNumbers.includes(hotel.judgment));
      
      // 都道府県のフィルタリング
      if (selectedPrefs.value.length > 0) {
        // 選択された都道府県に対応するmiddleClassCodeを取得
        const selectedCodes = selectedPrefs.value
          .map(pref => Object.keys(middleClassCodeMap).find(code => middleClassCodeMap[code] === pref))
          .filter(code => code); // undefinedを除外
        
        // 対応するmiddleClassCodeのホテルのみフィルタリング
        filtered = filtered.filter(hotel => selectedCodes.includes(hotel.middleClassCode));
      }
      
      return filtered;
    });

    // マーカークラスターを更新する関数
    const updateMarkerCluster = () => {
      if (!mapObject.value) return;
      
      // 既存のクラスターグループとマーカーを削除
      Object.values(clusterGroups).forEach(group => {
        if (group) mapObject.value.removeLayer(group);
      });
      // 緑マーカー用のレイヤーグループを削除
      if (clusterGroups.greenLayer) {
        mapObject.value.removeLayer(clusterGroups.greenLayer);
      }
      
      // 駐輪可（緑）- クラスター化なし、直接表示
      clusterGroups.greenLayer = L.layerGroup();
      
      // 要確認（黄）用クラスター - より強くクラスター化
      clusterGroups.yellow = L.markerClusterGroup({
        chunkedLoading: true,
        maxClusterRadius: 60,
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        disableClusteringAtZoom: 12
      });
      
      // 駐輪不可（赤）用クラスター - より強くクラスター化
      clusterGroups.red = L.markerClusterGroup({
        chunkedLoading: true,
        maxClusterRadius: 60,
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        disableClusteringAtZoom: 12
      });
      
      // フィルタリングされたホテルのマーカーを種類別に追加
      filteredHotels.value.forEach(hotel => {
        const marker = L.marker([hotel.latitude, hotel.longitude], {
          icon: getMarkerIcon(hotel.judgment),
          zIndexOffset: getZIndexOffset(hotel.judgment)
        });
        
        // ポップアップを追加
        marker.bindPopup(`
          <div class="hotel-info">
            <h3>${hotel.hotelName}</h3>
            <p>
              <a href="${hotel.hotelInformationUrl}" target="_blank" rel="noopener">
                ホテル情報を見る(楽天アフィ)
              </a>
            </p>
          </div>
        `);
        
        // judgmentに応じて適切なグループに追加
        if (hotel.judgment === 1) {
          clusterGroups.greenLayer.addLayer(marker); // クラスター化なし
        } else if (hotel.judgment === 2) {
          clusterGroups.yellow.addLayer(marker);
        } else {
          clusterGroups.red.addLayer(marker);
        }
      });
      
      // 各グループをマップに追加（赤→黄→緑の順で上に）
      mapObject.value.addLayer(clusterGroups.red);
      mapObject.value.addLayer(clusterGroups.yellow);
      mapObject.value.addLayer(clusterGroups.greenLayer);
      
      console.log('マーカー更新完了:', filteredHotels.value.length, '件');
    };
    // マップ準備完了時のコールバック
    const onMapReady = (map) => {
      mapObject.value = map;
      console.log('マップ準備完了');
      // 初期データがあれば表示
      if (filteredHotels.value.length > 0) {
        updateMarkerCluster();
      }
    };

    // フィルタ変更時にクラスターを更新
    watch(filteredHotels, () => {
      updateMarkerCluster();
    }, { deep: true });

    onMounted(async () => {
      // 環境に応じてデータ取得方法を切り替え
      try {
        if (process.env.VUE_APP_USE_MINIO === 'true') {
          // ローカル開発環境: MinIOからS3 SDKで取得
          console.log('MinIOからデータを取得中...');
          const s3Client = new S3Client({
            region: process.env.VUE_APP_AWS_REGION,
            endpoint: process.env.VUE_APP_AWS_ENDPOINT_URL,
            credentials: {
              accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
              secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
            },
            forcePathStyle: true, // MinIOではパススタイル必須
          });

          const command = new GetObjectCommand({
            Bucket: process.env.VUE_APP_AWS_S3_VIEW_BUCKET_NAME,
            Key: process.env.VUE_APP_HOTEL_DTO_FILE,
          });
            console.log('VUE_APP_AWS_S3_VIEW_BUCKET_NAME:', process.env.VUE_APP_AWS_S3_VIEW_BUCKET_NAME);

          const response = await s3Client.send(command);
          const bodyText = await response.Body.transformToString();
          const data = JSON.parse(bodyText);
          console.log('データ件数:', data.length, '件');
          hotels.value = data;
        } else {
          // 本番環境: CloudFrontから取得
          console.log('CloudFrontからデータを取得中...');
          console.log('データURL:', process.env.VUE_APP_HOTEL_DATA_URL);
          
          const response = await fetch(process.env.VUE_APP_HOTEL_DATA_URL);
          console.log('Response status:', response.status);
          console.log('Response Content-Type:', response.headers.get('content-type'));
          console.log('Response URL:', response.url);
          
          if (!response.ok) {
            const text = await response.text();
            console.error('Response error. Status:', response.status);
            console.error('Response body (first 500 chars):', text.substring(0, 500));
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const contentType = response.headers.get('content-type');
          const text = await response.text();
          
          console.log('Response text (first 200 chars):', text.substring(0, 200));
          
          if (!contentType || !contentType.includes('application/json')) {
            console.error('Expected JSON but got content-type:', contentType);
            console.error('Response body (first 1000 chars):', text.substring(0, 1000));
            throw new Error(`Expected JSON but got content-type: ${contentType}. URL may be incorrect.`);
          }
          
          const data = JSON.parse(text);
          console.log('データ件数:', data.length, '件');
          hotels.value = data;
        }
      } catch (error) {
        console.error('ホテル情報の取得に失敗しました:', error);
        console.error('環境変数の確認:');
        console.error('VUE_APP_USE_MINIO:', process.env.VUE_APP_USE_MINIO);
        console.error('VUE_APP_HOTEL_DATA_URL:', process.env.VUE_APP_HOTEL_DATA_URL);
        alert('ホテルデータの取得に失敗しました。詳細はコンソールを確認してください。');
      }
    });

    const toggleMenu = () => {
      isMenuOpen.value = !isMenuOpen.value;
      console.log('メニュー状態:', isMenuOpen.value);
    };
    
    // 全ての選択をクリアする関数
    const clearAllSelections = () => {
      selectedPrefs.value = [];
      visibleJudgments.value = [1, 2]; // デフォルト値に戻す
      isMenuOpen.value = false; // メニューを閉じる
      console.log('全ての選択がクリアされました');
    };
    
    // メニューを閉じる関数
    const closeMenu = () => {
      isMenuOpen.value = false;
    };
    
    // プライバシーポリシーを閉じる関数
    const closePrivacyPolicyOnly = () => {
      router.push('/');
    };
    
    // お問い合わせフォームを閉じる関数
    const closeContactForm = () => {
      router.push('/');
    };
    
    // サイドバーの展開/折り畳みを切り替え
    const toggleExpand = () => {
      isExpanded.value = !isExpanded.value;
    };
    
    // 地方ごとの都道府県リスト
    const prefectureGroups = {
      '北海道・東北': [
        '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県'
      ],
      '関東': [
        '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県'
      ],
      '中部': [
        '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県'
      ],
      '東海': [
        '岐阜県', '静岡県', '愛知県', '三重県'
      ],
      '九州・沖縄': [
        '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
      ],
      '近畿': [
        '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県'
      ],
      '中国': [
        '鳥取県', '島根県', '岡山県', '広島県', '山口県'
      ],
      '四国': [
        '徳島県', '香川県', '愛媛県', '高知県'
      ],
    };

    // 地方が全て選択されているか判定
    const isRegionSelected = (region) => {
      return prefectureGroups[region].every(pref => selectedPrefs.value.includes(pref));
    };

    // 地方チェックボックスの切り替え
    const toggleRegion = (region) => {
      const prefs = prefectureGroups[region];
      const allSelected = isRegionSelected(region);
      if (allSelected) {
        // すべて選択済み→すべて解除
        selectedPrefs.value = selectedPrefs.value.filter(pref => !prefs.includes(pref));
      } else {
        // すべて選択
        selectedPrefs.value = Array.from(new Set([...selectedPrefs.value, ...prefs]));
      }
    };

    // 都道府県ボタンクリック処理
    const handlePrefClick = (pref) => {
      console.log('クリックされた都道府県:', pref);
      console.log('現在の選択状態:', selectedPrefs.value);
      
      // 選択状態を手動で切り替え
      if (selectedPrefs.value.includes(pref)) {
        // 選択解除
        selectedPrefs.value = selectedPrefs.value.filter(p => p !== pref);
      } else {
        // 選択追加
        selectedPrefs.value = [...selectedPrefs.value, pref];
      }
      
      console.log('クリック後の選択状態:', selectedPrefs.value);
    };

    return {
      center,
      zoom,
      hotels,
      filteredHotels,
      getMarkerIcon,
      getZIndexOffset,
      prefectureGroups,
      selectedPrefs,
      isRegionSelected,
      toggleRegion,
      handlePrefClick,
      isMenuOpen,
      toggleMenu,
      clearAllSelections,
      closeMenu,
      showAboutSite,
      showPrivacyPolicyOnly,
      showContactForm,
      closeAboutSite,
      closePrivacyPolicyOnly,
      closeContactForm,
      visibleJudgments,
      isExpanded,
      toggleExpand,
      mapRef,
      onMapReady
    };
  }
});
</script>
<style scoped>
.app-wrapper {
  width: 100%;
  min-height: 100vh;
}

.map-container {
  display: flex;
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  position: relative;
}

.sidebar {
  width: 40vw;
  min-width: 400px;
  max-width: 650px;
  height: 100vh;
  background: #f8fafc;
  box-shadow: 2px 0 8px rgba(0,0,0,0.08);
  padding: 80px 24px 24px 24px;
  overflow-y: auto;
  z-index: 1100;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
}

.sidebar-header:first-child {
  margin-top: 0;
  padding-top: 0;
}

.filter-option {
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.filter-title {
  font-size: 13px;
  font-weight: bold;
  color: #2d3748;
  margin-bottom: 10px;
}

.filter-checkbox-label {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  color: #2d3748;
  cursor: pointer;
  user-select: none;
  margin-right: 16px;
  margin-bottom: 0;
}

.filter-checkbox-label:last-child {
  margin-right: 0;
}

.filter-checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  cursor: pointer;
}

.filter-pin-icon {
  margin-right: 6px;
  flex-shrink: 0;
}

.sidebar-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 0;
}

/* ドラッグハンドル（デフォルトでは非表示） */
.drag-handle {
  display: none;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  cursor: pointer;
  margin: 8px 0;
}

.drag-bar {
  width: 40px;
  height: 4px;
  background: #cbd5e0;
  border-radius: 2px;
}

/* 展開可能セクション（デフォルトでは常に表示） */
.expandable-section {
  display: block;
}

.sidebar-title {
  font-size: 16px;
  font-weight: bold;
  color: #2d3748;
  margin: 0;
  padding: 0;
  text-align: left;
  background: none;
  box-shadow: none;
  border: none;
}

/* サイドバー内のサイト情報 */
.sidebar-site-info {
  margin-top: 0;
  padding-top: 0;
  margin-bottom: 24px;
}

.sidebar-info-section {
  margin-bottom: 20px;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.sidebar-info-section:last-child {
  margin-bottom: 0;
}

.sidebar-info-section h3 {
  font-size: 15px;
  color: #2d3748;
  margin: 0 0 10px 0;
  padding-bottom: 6px;
  border-bottom: 2px solid #e2e8f0;
  font-weight: 600;
}

.sidebar-info-section p {
  font-size: 13px;
  line-height: 1.7;
  color: #4a5568;
  margin: 0;
}

.sidebar-info-section ul {
  margin: 8px 0 0 0;
  padding-left: 18px;
}

.sidebar-info-section ul li {
  font-size: 13px;
  line-height: 1.7;
  color: #4a5568;
  margin-bottom: 10px;
}

.sidebar-info-section ul li:last-child {
  margin-bottom: 0;
}

.sidebar-info-section ul li strong {
  color: #2d3748;
  font-weight: 600;
}

.affiliate-notice-sidebar {
  background: #fffbf0;
  border-left: 3px solid #ffc107;
}

.map-main {
  flex: 1;
  height: 100vh;
  width: 100%;
  position: relative;
}

/* 凡例（右上） */
.legend {
  position: absolute;
  top: 16px;
  right: 16px;
  background: white;
  padding: 10px 12px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.12);
  z-index: 1000;
  min-width: 100px;
}

.legend-title {
  margin: 0 0 8px 0;
  font-size: 11px;
  font-weight: bold;
  color: #2d3748;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 4px;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  font-size: 11px;
  color: #4a5568;
}

.legend-item:last-child {
  margin-bottom: 0;
}

.legend-icon {
  margin-right: 6px;
  flex-shrink: 0;
}

/* ページタイトル（左上固定位置） */
.page-title {
  position: fixed;
  width: 40vw;
  min-width: 400px;
  max-width: 650px;
  background: rgba(255, 255, 255, 0.95);
  padding: 12px 16px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  z-index: 2000;
  backdrop-filter: blur(4px);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-text {
  flex: 1;
}

.menu-container {
  position: relative;
}

/* ハンバーガーメニューボタン */
.hamburger-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.3s ease;
}

/* ドロップダウンメニュー */
.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 3000;
}

.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.menu-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  font-weight: normal;
  transition: background-color 0.2s ease;
}

.menu-item:hover {
  background-color: #f8f9fa;
}

.menu-item:first-child {
  border-radius: 8px 8px 0 0;
}

.menu-item:last-child {
  border-radius: 0 0 8px 8px;
}

.menu-icon {
  margin-right: 8px;
  font-size: 16px;
}

.hamburger-menu span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #333;
  border-radius: 1px;
  transition: all 0.3s ease;
  transform-origin: center;
}

.hamburger-menu:hover span {
  background-color: #007bff;
}

/* ハンバーガーメニューアクティブ状態（×印に変形） */
.hamburger-menu.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger-menu.active span:nth-child(2) {
  opacity: 0;
}

.hamburger-menu.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -6px);
}

/* サイドバー内の都道府県ボックススタイル */
.pref-checkbox-box {
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  position: static;
  max-width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.pref-fieldset {
  border: 1px solid #bbb;
  border-radius: 8px;
  padding: 8px 12px 6px 12px;
  min-width: 120px;
  background: #fafcff;
}
.pref-fieldset legend {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  padding: 0 6px;
}
.pref-checkbox-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}
.pref-checkbox-label {
  font-size: 14px;
  color: #222;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
}
/* チェックボックスを非表示にしてボタン風に */
.pref-checkbox-label input[type="checkbox"] {
  display: none;
}
.pref-checkbox-label.selected {
  background: #007bff;
  color: #fff;
  border-radius: 6px;
  padding: 8px 12px;
  border: 1px solid #007bff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
}
.pref-checkbox-label {
  background: #f3f6fa;
  border-radius: 6px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  transition: background 0.2s, color 0.2s;
}
.pref-checkbox-label:not(.selected):hover {
  background: #e6eef7;
  color: #007bff;
  border-color: #b3d1f7;
}
.region-checkbox-label {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  user-select: none;
}
.region-checkbox-label input[type="checkbox"] {
  margin-right: 6px;
}
.hotel-info h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 16px;
}
.hotel-info p {
  margin: 5px 0;
  font-size: 14px;
}
.hotel-info a {
  color: #007bff;
  text-decoration: none;
  user-select: none;
}

/* スマホ対応 */
/* タブレット対応 */
@media (max-width: 1200px) {
  .sidebar {
    width: 45vw;
    min-width: 380px;
    max-width: 550px;
    padding: 55px 20px 20px 20px;
  }
  
  .page-title {
    width: 45vw;
    min-width: 380px;
    max-width: 550px;
  }
  
  .pref-checkbox-box {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .pref-fieldset {
    min-width: 100px;
  }
  
  .pref-checkbox-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }
  
  .pref-checkbox-label {
    font-size: 13px;
    padding: 7px 10px;
    min-width: 70px;
  }
}

/* 小さいタブレット対応 */
@media (max-width: 900px) {
  .sidebar {
    width: 50vw;
    min-width: 320px;
    max-width: 450px;
    padding: 50px 16px 16px 16px;
  }
  
  .page-title {
    width: 50vw;
    min-width: 320px;
    max-width: 450px;
  }
  
  .pref-checkbox-label {
    font-size: 12px;
    padding: 6px 8px;
    min-width: 65px;
  }

  .site-info-container {
    margin-left: max(50vw, 320px);
    margin-right: 16px;
    padding-left: 16px;
  }
}

/* スマートフォン対応 */
@media (max-width: 768px) {
  .app-wrapper {
    display: flex;
    flex-direction: column;
  }
  
  .map-container {
    flex-direction: column;
  }
  
  /* ドラッグハンドルを表示 */
  .drag-handle {
    display: flex;
  }
  
  /* サイドバーを画面下部に配置 */
  .sidebar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    min-width: auto;
    max-width: none;
    height: auto;
    max-height: 85vh;
    padding: 0 16px 16px 16px;
    transition: transform 0.3s ease-out, max-height 0.3s ease-out;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.15);
    overflow-y: auto;
  }
  
  /* デフォルト状態：表示するピンまでの高さ */
  .sidebar:not(.expanded) {
    transform: translateY(calc(100% - 200px));
    overflow-y: hidden;
  }
  
  /* 展開状態 - 画面の一番上まで表示 */
  .sidebar.expanded {
    transform: translateY(0);
    overflow-y: auto;
    max-height: calc(100vh - 48px);
    height: calc(100vh - 48px);
    top: 48px;
    bottom: auto;
    border-radius: 0;
    padding: 16px;
  }
  
  /* 展開可能セクションの表示制御 */
  .expandable-section {
    overflow: visible;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.3s ease-out, opacity 0.3s ease-out;
  }
  
  .sidebar.expanded .expandable-section {
    max-height: none;
    opacity: 1;
  }
  
  .page-title {
    width: 100vw;
    min-width: auto;
    max-width: none;
    font-size: 16px;
    padding: 10px 12px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
  }
  
  .title-text {
    font-size: 16px;
  }
  
  .hamburger-menu {
    width: 22px;
    height: 18px;
  }
  
  .dropdown-menu {
    min-width: 140px;
    right: 0;
  }
  
  .menu-item {
    padding: 10px 12px;
    font-size: 13px;
  }
  
  .sidebar-header {
    margin-bottom: 12px;
    padding-bottom: 8px;
  }
  
  .sidebar-title {
    font-size: 16px;
  }
  
  .filter-option {
    padding: 10px 12px;
    margin-bottom: 12px;
  }
  
  .filter-checkbox-label {
    font-size: 12px;
    margin-right: 12px;
  }
  
  .filter-checkbox-label input[type="checkbox"] {
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }
  
  .filter-pin-icon {
    width: 12px;
    height: 16px;
    margin-right: 4px;
  }
  
  .pref-checkbox-box {
    padding: 12px;
    gap: 8px;
    grid-template-columns: 1fr;
  }
  
  .pref-fieldset {
    min-width: auto;
    padding: 6px 8px 4px 8px;
  }
  
  .pref-fieldset legend {
    font-size: 13px;
    padding: 0 4px;
  }
  
  .pref-checkbox-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }
  
  .pref-checkbox-label {
    font-size: 12px;
    padding: 6px 8px;
    min-width: 60px;
  }
  
  .map-main {
    height: 40vh;
    order: -1;
  }
}

/* 小さいスマートフォン対応 */
@media (max-width: 480px) {
  .page-title {
    font-size: 14px;
    padding: 8px 10px;
  }
  
  .title-text {
    font-size: 14px;
  }
  
  .sidebar {
    padding: 45px 12px 12px 12px;
  }
  
  .filter-checkbox-label {
    font-size: 11px;
    margin-right: 8px;
  }
  
  .pref-checkbox-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
  }
  
  .pref-checkbox-label {
    font-size: 11px;
    padding: 5px 6px;
    min-width: 50px;
  }
}

/* AboutSite用のスタイル */
.about-site-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
}

.about-site-body {
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;
}

/* PrivacyPolicyOnly用のスタイル */
.privacy-policy-only-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
}

.privacy-policy-only-body {
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;
}

.close-button {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #718096;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.close-button:hover {
  background-color: #e2e8f0;
  color: #2d3748;
}

/* スマホ対応 */
@media (max-width: 768px) {
  .close-button {
    font-size: 24px;
    width: 28px;
    height: 28px;
  }
}

/* サイト情報セクションのスタイル */
.site-info {
  width: 100%;
  background: #ffffff;
  border-top: 4px solid #007bff;
  padding: 48px 24px 32px 24px;
  min-height: 400px;
}

.site-info-container {
  max-width: 1200px;
  margin: 0 auto;
  margin-left: max(40vw, 400px);
  margin-right: 24px;
  padding-left: 24px;
}

.info-section {
  margin-bottom: 32px;
  padding: 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.info-section:last-of-type {
  margin-bottom: 24px;
}

.info-section h2 {
  font-size: 24px;
  color: #2d3748;
  margin: 0 0 16px 0;
  padding-bottom: 12px;
  border-bottom: 3px solid #007bff;
}

.info-section h3 {
  font-size: 18px;
  color: #2d3748;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e2e8f0;
}

.info-section p {
  font-size: 15px;
  line-height: 1.8;
  color: #4a5568;
  margin: 0;
}

.info-section ul {
  margin: 12px 0 0 0;
  padding-left: 20px;
}

.info-section ul li {
  font-size: 15px;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 12px;
}

.info-section ul li:last-child {
  margin-bottom: 0;
}

.info-section ul li strong {
  color: #2d3748;
  font-weight: 600;
}

.affiliate-notice {
  background: #fff8e1;
  border-left: 4px solid #ffc107;
}

.footer-links {
  text-align: center;
  margin: 24px 0 16px 0;
  padding: 16px 0;
  border-top: 1px solid #cbd5e0;
}

.footer-links a {
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: #0056b3;
  text-decoration: underline;
}

.footer-links .separator {
  margin: 0 12px;
  color: #cbd5e0;
}

.copyright {
  text-align: center;
  margin-top: 16px;
}

.copyright p {
  font-size: 13px;
  color: #718096;
  margin: 0;
}

/* タブレット対応 - サイト情報 */
@media (max-width: 1200px) {
  .site-info {
    padding: 40px 20px 28px 20px;
  }

  .site-info-container {
    margin-left: max(45vw, 380px);
    margin-right: 20px;
    padding-left: 20px;
  }

  .info-section {
    padding: 20px;
    margin-bottom: 24px;
  }

  .info-section h2 {
    font-size: 22px;
  }

  .info-section h3 {
    font-size: 17px;
  }
}

/* スマートフォン対応 - サイト情報 */
@media (max-width: 768px) {
  .site-info {
    padding: 32px 16px 24px 16px;
  }

  .site-info-container {
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
  }

  .info-section {
    padding: 16px;
    margin-bottom: 20px;
  }

  .info-section h2 {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .info-section h3 {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .info-section p,
  .info-section ul li {
    font-size: 14px;
    line-height: 1.7;
  }

  .footer-links a {
    font-size: 13px;
  }

  .footer-links .separator {
    margin: 0 8px;
  }

  .copyright p {
    font-size: 12px;
  }
}

/* 小さいスマートフォン対応 - サイト情報 */
@media (max-width: 480px) {
  .site-info {
    padding: 24px 12px 20px 12px;
  }

  .info-section {
    padding: 14px;
    margin-bottom: 16px;
  }

  .info-section h2 {
    font-size: 18px;
  }

  .info-section h3 {
    font-size: 15px;
  }

  .info-section p,
  .info-section ul li {
    font-size: 13px;
  }

  .footer-links {
    padding: 12px 0;
  }

  .footer-links a {
    font-size: 12px;
  }
}
</style>